import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { LendingProvider } from './lending-provider';

export const LendingProviderModule: string = ng
    .module('lending-provider', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('lendingProvider', LendingProvider)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/lending-provider/lending-provider.module.ts